import React from "react";
import PropTypes from "prop-types";
import { SFStack, SFTypography, getStyled, SFCard, SFCardBody } from "@sf-core";
const { styled } = getStyled();

const StyledWrapper = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const StyledCard = styled(SFCard)(({ theme, noBorder }) => ({
  height: "100%",
  ...(noBorder && {
    border: "none",
    boxShadow: "none",
  }),
}));

const SFBasicCard = ({
  cardHeader,
  cardContent,
  actionButtons = [],
  noBorder = false,
}) => {
  return (
    <StyledCard noBorder={noBorder}>
      <SFCardBody>
        <SFStack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <SFTypography variant="cardSectionHeading">{cardHeader}</SFTypography>
          <SFStack direction="row" alignItems="center" spacing={1}>
            {actionButtons}
          </SFStack>
        </SFStack>
        <StyledWrapper>{cardContent}</StyledWrapper>
      </SFCardBody>
    </StyledCard>
  );
};

SFBasicCard.propTypes = {
  cardHeader: PropTypes.string,
  actionButtons: PropTypes.array,
  cardContent: PropTypes.node,
};

export default SFBasicCard;
